import {
  Walk,
  Ferry,
  CableCar,
  Rail,
  Bus,
  Tram,
  Underground,
  Drive,
  Park,
  Cycle,
  CycleDock,
  Destination,
  Plane,
  EvStation,
} from "./index";

export const IconMapping = {
  Walk: Walk,
  Rail: Rail,
  Bus: Bus,
  Ferry: Ferry,
  CableCar: CableCar,
  Cycle: Cycle,
  CycleDock: CycleDock,
  CycleStreetsQuietest: Cycle,
  CycleStreetsFastest: Cycle,
  CycleStreetsBalanced: Cycle,
  CycleStreetsDefault: Cycle,
  Tram: Tram,
  Metro: Tram,
  Coach: Bus,
  Underground: Underground,
  Drive: Drive,
  ElectricVehicle: Drive,
  Park: Park,
  PlatformChange: Walk,
  EvStation: EvStation,
  Flight: Plane,
  Destination: Destination,
};
